import { Box, Typography } from "@mui/material";
import React from "react";
import CustomSkillsAutocomplete from "../shared/CustomSkillsAutocomplete";
import Skills from "../../../../types/Skills";
import Skill from "../../../../types/Skill";

interface SkillsSummarySectionProps {
  skills: Skills;
  setSkills: React.Dispatch<React.SetStateAction<Skills>>;
  error: string;
  removeErrorMessage: (field: string) => void;
  allSkills: Skill[];
  onCreateNewSkill: (name: string, type: Skill["type"]) => Promise<Skill>;
}

export const SkillsSummarySection: React.FC<SkillsSummarySectionProps> = ({
  skills,
  setSkills,
  error,
  removeErrorMessage,
  allSkills,
  onCreateNewSkill,
}) => {
  return (
    <Box>
      <Typography variant="h4">Skill Summary</Typography>
      <Box sx={{ border: "1px solid black" }}></Box>
      <CustomSkillsAutocomplete
        skills={skills}
        setSkills={setSkills}
        error={error}
        removeErrorMessage={removeErrorMessage}
        allSkills={allSkills}
        onCreateNewSkill={onCreateNewSkill}
      />
    </Box>
  );
};
